import styled from 'styled-components';

import { ASCENDING, DESCENDING } from 'constants/sortDirections';

import { BasicTable, BasicTableWrapper } from './BasicTable';
import * as cellTypes from './cellTypes';
import { defaultQueryParams, formatSortAndOrder } from './helpers';
import { filterRows, splitTableColumns, sortByObjValue as sortRows } from './utils';
import { MobileTable } from './MobileTable';
import { NoResults } from './NoResults';
import Table from './Table';
import { TableBody } from './TableBody';
import { TableHeader } from './TableHeader';
import { TableHeaderCell } from './TableHeaderCell';
import { StyledSummaryRow } from './StyledRow.styled';
/*
 * The padding on the bottom of the table cell is a tempoary workaround for table cells overflowing
 * https://iterable.quip.com/jDRoAttthIME/Table-Overflow-Bug
 */
const TableWithPaddedOverflow = styled(Table)`
  [data-role='body-wrapper'] {
    padding-bottom: 80px;
  }
`;

export default Table;
export {
  ASCENDING,
  BasicTable, // the new React table
  BasicTableWrapper, // the wrapper around the new React table
  cellTypes,
  defaultQueryParams,
  DESCENDING,
  filterRows,
  formatSortAndOrder,
  MobileTable,
  NoResults,
  splitTableColumns,
  sortRows,
  StyledSummaryRow,
  TableBody, // the new React table body
  TableHeader, // the new React table header
  TableHeaderCell,
  TableWithPaddedOverflow,
};
export * from './TableMeta'; // the new React table meta container
